import { graphql } from "@/lib/gql/__generated__/gql";

export const VoucherIssuedMarkVoucherAsUsed_DetailsPage_Mutation = graphql(/* GraphQL */ `
	mutation VoucherIssuedMarkVoucherAsUsed_DetailsPage($input: VoucherIssuedForCampaignMarkVoucherAsUsedInput!) {
		voucherIssuedForCampaignMarkVoucherAsUsed(input: $input) {
			userErrors
			voucherIssuedForCampaign {
				hotelID
				voucherCode
				userECReceiptID
				usedReservationID
				useableStartDt
				cinStart
				cinEnd
				guestName
				guestEmail
				guestPostalCode
				guestAddress
				guestTel
				sendingMethod
				resourceAvailablePrice {
					currencyType
					amount
				}
				createdAt
				createdDt
				usedAt
			}
		}
	}
`);
